export default "__VITE_ASSET__qgDvKZJF__"